"use client";

import { cn } from "@drpcrd/utils/shared";
import { CheckboxCheck } from "./icons/checkbox-check";

type SelectableCheckboxProps = {
  isSelected: boolean;
  className?: string;
  onClick?: () => void;
};

/**
 * A customizable checkbox component that can be used to represent selection states
 */
export const SelectableCheckbox = ({
  isSelected,
  onClick,
  className,
}: SelectableCheckboxProps) => {
  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  if (isSelected) {
    return (
      <div
        className={cn(
          "bg-primary rounded-xs relative flex h-2.5 w-2.5 cursor-pointer items-center justify-center p-0.5",
          className,
        )}
        onClick={handleClick}
        role="checkbox"
        aria-checked={true}
        tabIndex={-1}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            handleClick();
            e.preventDefault();
          }
        }}
      >
        <CheckboxCheck className="h-[8px] w-[10px] object-contain" />
      </div>
    );
  }

  return (
    <div
      className={cn(
        "rounded-xs relative flex h-2.5 w-2.5 cursor-pointer items-center justify-center border border-neutral-900 bg-white p-0.5",
        className,
      )}
      onClick={handleClick}
      role="checkbox"
      aria-checked={false}
      tabIndex={-1}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          handleClick();
          e.preventDefault();
        }
      }}
    >
      <div className="h-[8px] w-[10px] object-contain"></div>
    </div>
  );
};
